export default __webpack_public_path__ + "static/media/andes_a_la_selva_7.9e756b1f.JPG";